<template>
	<div class="lane__closure__view__info">
		<div class="d-flex lcr-main-summary" v-if="!$store.state.isMobile">
			<div class="lcr-main-summary__info">
				<div class="lcr-summary__label">Info</div>
				<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
				<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>
			</div>
			<div class="lcr-main-summary__info flex-grow-1">
				<div class="lcr-summary__label">Affected Streets</div>
				<div class="lcr-summary__value">{{directionOfTravel()}}</div>
				<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
				<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
			</div>
			<div class="lcr-main-summary__info pt-4">
				<div class="show-on-map-wrapper">
					<a class="show-on-map text-left" @click="showOnMap">
						<span v-if="hideMap" class="on-container">
							<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
							<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
						</span>
						<span v-else class="on-container">
							<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
							<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
						</span>
					</a>
				</div>
			</div>
			<div class="lcr-main-summary__info">
				<div class="lcr-summary__label">Primary Reason for Closure</div>
				<div class="lcr-summary__value">{{natureOfWork()}}</div>
			</div>
			<div class="lcr-main-summary__info ">
				<div class="lcr-summary__label">Date(s)</div>
				<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('MM/DD/YYYY')}} - {{moment(laneClosureRequest.toDate.value).format('MM/DD/YYYY')}}</div>
				<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('H:mm')}} - {{moment(laneClosureRequest.toDate.value).format('H:mm')}}</div>
				<div class="lcr-summary__value" v-if="laneClosureRequest.isUnderTwoHours.value == 1"><span class='badge bg-two-hours' style='margin-top:3px; margin-right:6px; position:relative;'>2 hours</span></div>

			</div>
			<div class="lcr-main-summary__info" v-if="laneClosureRequest.changeRequest != null">
				<div class="lcr-summary__label">Complete Status</div>
				<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.changeRequest.completeTypeId)}}</div>
				<div class="lcr-summary__label">Changes<br/>Approval Status</div>
				<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.changeRequest.approvalStatusId)}}</div>
				<div class="lcr-summary__label">Record Status</div>
				<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.changeRequest.recordStatusId)}}</div>
			</div>

		</div>

		<div class="lcr-main-summary lcr-main-summary-mobile shrink" v-if="$store.state.isMobile">
			<div class="lcr-detail-header">
				<div class="lcr-detail-title">
					<b-row>
						<b-col cols="10">
							<h2>
								<span v-html="parseLocation(laneClosureRequest.affectedStreet.value, laneClosureRequest.firstCrossStreet.value, laneClosureRequest.lastCrossStreet.value, laneClosureRequest.directionId.value, laneClosureRequest.isUnderTwoHours.value).replace('<br/>', ', ')"></span>
								<span v-if="laneClosureRequest.isUnderTwoHours.value == 1" class='badge bg-two-hours'>2 hours</span>
							</h2>
							<div class="lcr-id">
								<span v-if="laneClosureRequest.changeRequest" class="mr-3">Requested Changes #{{laneClosureRequest.changeRequest.id}}</span>
								<span v-else class="mr-3">No Requested Changes</span>
							</div>
						</b-col>
						<b-col cols="2">
							<div class="show-on-map-wrapper">
								<a class="show-on-map" @click="showOnMap">
									<span class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-details.svg" alt="on-badge" />
									</span>
								</a>
							</div>
						</b-col>
					</b-row>
				</div>
				<div class="lcr-detail-info">
					<b-row>
						<b-col cols="9" class="exclude-outside-click" @click="showLcrDetailsPanel = !showLcrDetailsPanel">
							<span>{{moment(laneClosureRequest.fromDate.value).format('MM/DD/YYYY')}} - {{moment(laneClosureRequest.toDate.value).format('MM/DD/YYYY')}}</span> @
							<span>{{moment(laneClosureRequest.fromDate.value).format('H:mm')}} - {{moment(laneClosureRequest.toDate.value).format('H:mm')}}</span>
						</b-col>
						<b-col cols="3 text-right">
							<a href="#" class="exclude-outside-click lcr-show-details" :class="{'active': showLcrDetailsPanel}" @click.prevent="showLcrDetailsPanel = !showLcrDetailsPanel"><span class="exclude-outside-click" v-html="moreOrLess">More</span> <img class="on-map responsive-img exclude-outside-click" src="@/assets/chevron-down.svg" alt="chevron-down" /></a>
						</b-col>
					</b-row>
				</div>
			</div>
			<div v-click-outside="hideLcrDetails" class="lcr-details-panel" :class="showLcrDetailsPanel ? 'slidedown' : 'slideup'">


				<div class="lcr-main-summary__info">
					<div class="lcr-summary__label">Info</div>
					<div class="lcr-summary__value">
								<span v-if="laneClosureRequest.trafficManagementRef.value" class="mr-3">TM: {{laneClosureRequest.trafficManagementRef.value}}</span>
								<span>LCR: {{laneClosureRequest.id}}</span>
					</div>
			</div>

				<div class="lcr-main-summary__info" v-if="laneClosureRequest.requesterProjectName">
					<div class="lcr-summary__label">Project</div>
					<div class="lcr-summary__value">
						{{laneClosureRequest.requesterProjectName}}
					</div>
				</div>
				<div class="lcr-main-summary__info" v-if="laneClosureRequest.changeRequest">
					<div class="lcr-summary__label">Changes Status</div>
					<div class="lcr-summary__value">
						{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.changeRequest.recordStatusId)}} - {{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.changeRequest.approvalStatusId)}}
					</div>
				</div>
				<div class="lcr-main-summary__info" v-if="laneClosureRequest.changeRequest && laneClosureRequest.changeRequest.completeTypeId != null">
					<div class="lcr-summary__label">Complete Status</div>
					<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.changeRequest.completeTypeId)}}</div>
				</div>
				<div class="lcr-main-summary__info">
					<div class="lcr-summary__label">Primary Reason for Closure</div>
					<div class="lcr-summary__value">{{natureOfWork()}}</div>
				</div>
			</div>


			<div class="lcr-main-summary__info pt-4" v-if="!$store.state.isMobile">
				<div class="show-on-map-wrapper">
					<a class="show-on-map text-left" @click="showOnMap">
						<span v-if="hideMap" class="on-container">
							<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
							<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
						</span>
						<span v-else class="on-container">
							<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
							<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import Format from '../utility/Format';
import LaneClosureRequest from '../models/LaneClosureRequest';

Vue.directive('click-outside', {
	bind: function(el, binding, vNode) {
	// Provided expression must evaluate to a function.
	// if (typeof binding.value !== "function") {
	// 	const compName = vNode.context.name;
	// 	let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
	// 	if (compName) {
	// 	warn += `Found in component '${compName}'`;
	// 	}
	// }
	// Define Handler and cache it on the element
	const bubble = binding.modifiers.bubble;
	const handler = e => {
		let excludedClasses = ["exclude-outside-click"];
		if (excludedClasses.some(excludedClass => e.target.classList.contains(excludedClass))) return;
		if (bubble || (!el.contains(e.target) && el !== e.target)) {
		binding.value(e);
		}
	};
	el.__vueClickOutside__ = handler;
	// add Event Listeners
	document.addEventListener("click", handler);
	},
	unbind: function(el, binding) {
	// Remove Event Listeners
	document.removeEventListener("click", el.__vueClickOutside__);
	el.__vueClickOutside__ = null;
	}
  })

export default {
	props: ['value'],
	data() {
		return {
			LaneClosureRequest,
			hideMap: false,
			showLcrDetailsPanel: false,
			scrollPosition: null
		}
	},
	computed: {
		moreOrLess() {
			if (this.showLcrDetailsPanel) {
				return "Hide";
			}
			return "More";
		},
		laneClosureRequest() {
			return this.value;
		},
	},
	methods: {
		hideLcrDetails() {
			this.showLcrDetailsPanel = false
		},
		parseLocation(loc1, loc2, loc3, directionId, isUnderTwoHours) {
			let location = "";

			location += "<strong style='color:#293C7C;'>";
			if (directionId) {
				location += LaneClosureRequest.getDirectionAbbreviationText(directionId) + " ";
			}
			location += loc1 ? loc1 : ' '
			location += "</strong>";
			location = location && loc2 ? `${location}<br/>${loc2 ? loc2 : ' '}` : location
			location = location && loc3 ? `${location} to ${loc3 ? loc3 : ' '}` : location



			return location
		},
		updateScroll() {
			this.scrollPosition = document.getElementById('main').scrollTop;
		},
		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle", null, this.hideMap ? 0 : 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);

				// this.setAllPolylineColours();
			});
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				let response = Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions);
				if (response) {
					return response.name;
				} else {
					console.log("directionOfTravel", response);
				}
			}
			return null;
		},
		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
	},
	mounted() {
		document.getElementById('main').addEventListener('scroll', (event) => {
			this.updateScroll();
		});
	}
}
</script>

<style>

</style>